export function formatVisitDate(isoDate: string): string {
  return new Date(isoDate).toLocaleString();
}
